import queryString from 'query-string'

export function parseQuery(search) {
  return queryString.parse(search ? search.replace(/^\?/, '') : '')
}

/** One-time token from the activate/reset URL only (never the session JWT). */
export function getPasswordResetUrlToken(location = {}) {
  const queryToken = location?.query?.token
  if (queryToken) return queryToken

  if (location?.search) {
    const parsed = parseQuery(location.search)
    if (parsed?.token) return parsed.token
  }

  return null
}

export function getPasswordResetToken(location = {}, user = {}) {
  return getPasswordResetUrlToken(location) || user?.token || user?.access_token || null
}

export function isPasswordRecoveryPath(pathname = '') {
  return pathname.startsWith('/users/activate') || pathname.startsWith('/users/reset')
}

/** Paths that should be restored after the same user logs back in. */
export function isRememberableLastPath(pathname = '') {
  if (!pathname || pathname === '/login') return false
  return !isPasswordRecoveryPath(pathname)
}

/**
 * Build a react-router v3-shaped location for legacy route callbacks and components.
 */
export function buildV3Location(location, params = {}) {
  const query = parseQuery(location.search)
  return {
    ...location,
    params,
    query,
    location,
  }
}

export function getInitialLocation() {
  if (typeof window === 'undefined') {
    return { pathname: '/', search: '', hash: '', state: null, params: {}, query: {} }
  }
  const { pathname, search, hash, state } = window.location
  return buildV3Location({ pathname, search, hash, state })
}

/**
 * Stable string key for route effects — pathname only; params are already encoded in the path.
 */
export function getStableRouteKey(location) {
  const { pathname = '', search = '', hash = '' } = location || {}
  return `${pathname}${search}${hash}`
}
